<template>
  <v-card v-if="r" outlined class="ma-4">
    <v-card-text>
      <v-row no-gutters align="center">
        <v-col cols="3" class="text-capitalize">
          <small>Cod: </small><strong>{{r.code}}</strong>
        </v-col>
        <v-col cols="3" class="text-capitalize">
          <small>Check-In: </small><strong>{{r.check_in | datify}}</strong><br/>
          <small>Check-Out: </small><strong>{{r.check_out | datify}}</strong>
        </v-col>
        <v-col cols="3" class="text-capitalize">
          <small>Total: </small><strong>{{r.total_price}} {{r.currency}}</strong>
        </v-col>
        <v-col cols="3" class="text-capitalize">
          <v-chip label>
            {{r.status}}
          </v-chip>
        </v-col>
      </v-row>
    </v-card-text>

    <v-card v-for="(room, index) in r.rooms" :key="index" outlined class="ma-2" >
      <v-card-text>
        <v-row no-gutters align="center">
          <v-col cols="3">
            <small>Camera: </small><strong>{{room.room_type_name}}</strong><small> ({{room.room_type_id}})</small><br>
            <small>Plan Tarifar: </small><strong>{{room.rate_plan_name}}</strong><small> ({{room.rate_plan_id}})</small>
          </v-col>
          <v-col cols="3">
            <small>Check-In: </small><strong class="text-capitalize">{{room.check_in | datify}}</strong><br>
            <small>Check-Out: </small><strong class="text-capitalize">{{room.check_out | datify}}</strong>
          </v-col>
          <v-col cols="3">
            <small>Total: </small><strong>{{room.total_price}} {{r.currency}}</strong>
          </v-col>
          <v-col cols="3">
            <v-chip label class="text-capitalize">
              {{room.status}}
            </v-chip>
          </v-col>
        </v-row>

        <v-divider class="my-2"/>

        <v-row no-gutters>
          <v-col cols="3" v-for="(guest, index) in room.guests" :key="index">
            <v-chip large label style="width: 100%">
              <v-list-item-avatar class="mr-2" large>
                <v-icon>mdi-account-circle</v-icon>
              </v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-title>{{guest.first_name}} {{guest.last_name}}</v-list-item-title>
                <v-list-item-subtitle><small>{{guest.birthdate}}, {{guest.country}}</small></v-list-item-subtitle>
              </v-list-item-content>
            </v-chip>
          </v-col>
        </v-row>


        </v-card-text>

    </v-card>


  </v-card>
</template>


<script>

  import moment from "moment";
  import reservation_repository from "@/repositories/reservation-repository";

  export default {

    props: {
      reservation: Object
    },

    data: () => ({
      r: null
    }),

    async created() {
      this.r = await reservation_repository.getReservation(this.reservation.id);
    },

    filters: {
      datify: function (value) {
        if (!value) return 'N/A';
        return moment(value, 'YYYY-MM-DD hh:mm:ss').format('LL');
      }
    }
  }
</script>